import { createFileRoute } from "@tanstack/react-router";

import { Alert } from "@/components/base/alert";
import { DismissibleAlert } from "@/components/base/dismissible-alert";
import { Link } from "@/components/base/link";
import { title } from "@/components/base/primitives";
import { LoginForm } from "@/components/users/login-form";
import { ParentLinkAlert } from "@/components/users/parent-link-alert";
import { DefaultLayout } from "@/layouts/default";

export const Route = createFileRoute("/log-in")({
  validateSearch: (
    search: Record<string, unknown>,
  ): {
    next?: string;
    passwordReset?: boolean;
  } => {
    return {
      next: search.next?.toString(),
      passwordReset: search.passwordReset === true || undefined,
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { next, passwordReset } = Route.useSearch();

  return (
    <DefaultLayout>
      <div className="mx-auto flex max-w-xl flex-col space-y-6 px-3 text-center">
        <h1 className={title({ size: "lg" })}>Sign In To CBVA</h1>

        <p>
          Don’t have an account? <Link to="/sign-up">Sign Up</Link>
        </p>
      </div>

      <div className="mx-auto flex w-full max-w-md flex-col space-y-4 px-3">
        {passwordReset ? (
          <Alert
            color="success"
            title="Password Reset Successful"
            description="Your password has been reset. Please log in with your new password."
          />
        ) : (
          <DismissibleAlert
            dismissKey="login-migration-info"
            color="info"
            title="Important: Password Reset Required"
            description={
              <>
                We migrated to a new system in <strong>2026</strong>. To access
                your existing account, please use the{" "}
                <Link
                  to="/account/forgot-password"
                  className="font-medium underline"
                >
                  Forgot Password
                </Link>{" "}
                option to set a new password. If you don't remember your email,
                try{" "}
                <Link to="/account/recover" className="font-medium underline">
                  account recovery
                </Link>
                .
              </>
            }
          />
        )}

        {!passwordReset && <ParentLinkAlert />}

        <LoginForm next={next} className="w-full rounded-lg bg-white p-8" />
      </div>
    </DefaultLayout>
  );
}
